// This file is automatically generated. Do not edit it directly.
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";

const SUPABASE_URL = "https://jwwoipblrxntcahgwdqx.supabase.co";
const SUPABASE_PUBLISHABLE_KEY =
  "sb_publishable_QIQOAsQ2SAlaq_YkxeLLhw_lHhLYuGy";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY
);
